const axios = require('axios')
const { constants } = require('../config' )

axios.defaults.baseURL = `${constants.NEW_EO_API_HOST}`

export default async function ({ redirect, route }) {
  const { fullPath, path, query } = route
  if (path !== '/publication' && path !== '/publication/') {
    return
  }

  const errorPage = `/error${fullPath}`

  const {
    id,
    'model-id': modelId,
  } = query

  let {
    role,
    slug,
  } = query

  // Check if mandatory information is available
  if (!slug && !id) {
    return redirect(errorPage)
  }

  const articleRoute = async () => {
    if (!slug) {
      const {
        data: {
          item: {
            slug:pubSlug = {},
          } = {},
        } = {},
      } = await axios.get(`/articles/${id}`)
      slug = pubSlug
    }
    return redirect(301, `/artikel/${slug}`)
  }

  const campaignRoute = async () => {
    if (!slug) {
      const {
        data: {
          item: {
            slug: pubSlug = {},
          } = {},
        } = {},
      } = await axios.get(`/campaign/${id}`)
      slug = pubSlug
    }
    return redirect(301, `/campagne/${slug}`)
  }

  const personRoute = async () => {
    if (!id && !slug) {
      return redirect(errorPage)
    }

    /**
     * Available routes for different roles
     * order in priority for people with multiple roles
     * key: slug from prepr
     * value: route in webapp
     */
    const availableRoutes = {
      contactpersoon: '/pers/contactpersonen',
      presentator: '/pers/presentatoren',
    }

    /**
     * use provided role as priority role if given and available
     */
    let route = role && availableRoutes[role]

    /**
     * Get slug or roles from api when not provided
     */
    if (!route || !slug) {
      const personIdOrQuery = id || `?slug=${slug}`

      const res = await axios.get(`/persons/${personIdOrQuery}`, {
        params: {
          domain: 'generieke-content-eo',
          limit: 1,
        },
      })

      const person = res?.data?.item || res?.data?.items?.[0]
      const roles = person?.role?.items
      if (roles) {
        const firstMatch = Object.entries(availableRoutes).find(([slug]) => {
          return roles.find(item => item.slug === slug)
        })
        if (firstMatch && firstMatch.length === 2) {
          route = firstMatch[1]
        }
      }
      slug = person?.slug
    }

    if (!route) {
      return redirect(errorPage)
    }

    return redirect(301, `${route}/${slug}`)
  }

  const programRoute = async () => {
    if (!slug) {
      const {
        data: {
          item: {
            slug: pubSlug = {},
          } = {},
        } = {},
      } = await axios.get(`/programs/${id}`, {
        params: {
          aggregate: 0,
          press: 1,
        },
      })
      slug = pubSlug
    }
    return redirect(301, `/pers/programmas/${slug}`)
  }

  const pressreleaseRoute = async () => {
    if (!slug) {
      const {
        data: {
          item: {
            slug: pubSlug = {},
          } = {},
        } = {},
      } = await axios.get(`/pressreleases/${id}`)
      slug = pubSlug
    }
    return redirect(301, `/pers/${slug}`)
  }

  const pageRoute = async () => {
    if (!slug) {
      const {
        data: {
          item: {
            slug: pubSlug = {},
          } = {},
        } = {},
      } = await axios.get(`/pages/${id}`)
      slug = pubSlug
    }
    return redirect(301, `/${slug}`)
  }

  if (modelId) {
    switch (modelId) {
      case '9ad0aecf-f7f9-431c-9193-52bc5bc22971': // article
        return await articleRoute()
      case 'd297be78-bf58-4270-96a0-b9aec336f952': // campaign
        return await campaignRoute()
      case '3e97b652-7f9f-4b47-91ef-5f63b448a983': // person
        return await personRoute()
      case 'fa9af868-5af3-49db-8b55-ff1155b2a53b': // program
        return await programRoute()
      case '4eb98198-f298-48f7-94e9-d0db0fea7d37': // pressrelease
        return await pressreleaseRoute()
      case 'eceb6d16-a6e8-439c-88d8-286c97a580ff': // page
        return await pageRoute()
    }
    return
  }

  if (slug) {
    return redirect(301, slug)
  }

  redirect(errorPage)
}
